import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusCircle, Trash2, Loader2, ChevronRight } from 'lucide-react'; 
import axios from 'axios';
import './MemoiresNonMentionnes.css';

// 1. On récupère onThesisClick depuis les props
function MemoiresNonMentionnes({ onThesisClick }) {
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem("role") === "admin";

  const [unmentionedTheses, setUnmentionedTheses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMemoires = async () => {
      try {
        setLoading(true);
        const res = await axios.get("https://api.memofacdz.com/api/memoires-non-mentionnes");
        setUnmentionedTheses(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Erreur lors du fetch:", err);
        setError("Impossible de charger les mémoires.");
        setLoading(false);
      }
    };
    fetchMemoires();
  }, []);

  const handleDelete = async (id, title, e) => {
    // 2. IMPORTANT : on arrête la propagation pour ne pas ouvrir les détails en supprimant
    e.stopPropagation(); 
    if (window.confirm(`Voulez-vous vraiment supprimer "${title}" ?`)) {
      try {
        const token = localStorage.getItem("token");
        await axios.delete(`https://api.memofacdz.com/api/memoires-non-mentionnes/${id}`, {
         headers: { Authorization: `Bearer ${token}` }
        });
        setUnmentionedTheses(unmentionedTheses.filter(t => t._id !== id));
        alert("Mémoire supprimé !");
      } catch (err) {
        alert("Erreur lors de la suppression.");
      }
    }
  };

  return (
    <div className="memoires-non-mentionnes-page">
      <section className="theses-content-wrapper">
        <main className="theses-main-content">
          <div className="theses-header">
            <h1>Memoires non-mentionnées (Divers)</h1>
            {isAdmin && (
              <button className="add-memoire-page-btn" onClick={() => navigate("/add-memoireNM")}>
                <PlusCircle size={18} /> Ajouter un Mémoire
              </button>
            )}
            <p className="subtitle">
              Cette section liste les thèses antérieures non indexées par année.
            </p>
          </div>
          
          <div className="theses-list">
            {loading && (
              <div className="loading-state">
                <Loader2 className="spinner" /> Chargement des mémoires...
              </div>
            )}

            {error && <p className="error-message">{error}</p>}

            {!loading && unmentionedTheses.length === 0 && <p>Aucun mémoire trouvé.</p>}

            {!loading && unmentionedTheses.map((thesis) => (
              /* 3. On rend la carte cliquable avec onThesisClick */
              <div 
                key={thesis._id} 
                className="thesis-card clickable-card"
                onClick={() => onThesisClick && onThesisClick(thesis)}
              >
                <div className="thesis-card-content">
                
                  {thesis.Couverture_R && (
                      <img 
                        src={thesis.Couverture_R ?`https://api.memofacdz.com${thesis.Couverture_R}`  : "/placeholder-cover.jpg"} 
                        alt="Couverture" 
                        className="thesis-mini-cover" 
                      />
                    )}
                    <div className="thesis-card-info">
                  <h3>{thesis.intitule_M}</h3>
                  <p>Auteur: <strong>{thesis.Ecrivain}</strong> </p>
                </div>
                </div>

                <div className="card-actions">
                  <span className="click-instruction">Détails <ChevronRight size={14}/></span>
                  
                  {isAdmin && (
                    <button 
                      className="delete-memoire-btn"
                      onClick={(e) => handleDelete(thesis._id, thesis.intitule_M, e)}
                    >
                      <Trash2 size={20} />
                    </button>
                  )}
                </div>
              </div>
            ))}
            
            {isAdmin && unmentionedTheses.length > 0 && (
              <div className="admin-actions-bottom">
                <button className="add-memoire-page-btn" onClick={() => navigate("/add-memoireNM")}>
                  <PlusCircle size={18} /> Nouveau Mémoire
                </button>
              </div>
            )}
          </div>
        </main>
      </section>
    </div>
  );
}

export default MemoiresNonMentionnes;